/**
 * Does nothing for all your needs.
 * @function
 */
export default function () {
  return;
}